import { PlusCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import CSPage from '../../components/CSPage';
import CSPageHeader from '../../components/CSPageHeader';
import { generateUuid } from '../../shared/utils';
import HolisticProjectsList from './HolisticProjectsList';

function ListHolisticProjectsPage() {
  const holisticProjectId = useMemo(() => {
    return generateUuid();
  }, []);
  return (
    <>
      <CSPage containerStyle={{ maxWidth: 'unset' }} title="Holistic Projects">
        <CSPageHeader
          title="Holistic Projects"
          topActions={[
            <Link
              key="add"
              to={{
                pathname: `/holistic-project/edit/${holisticProjectId}`,
                state: {
                  mode: 'create',
                },
              }}
            >
              <Button type="link" icon={<PlusCircleOutlined />} size="large">
                Add a holistic project
              </Button>
            </Link>,
          ]}
        />
        <HolisticProjectsList />
      </CSPage>
      <style jsx>{``}</style>
    </>
  );
}

export default ListHolisticProjectsPage;
